module.exports = __webpack_public_path__ + "img/p-2.974786f7.png";